"use client"

import React, { useState, useEffect } from "react"
import "./Slider.css"

const Slider = React.forwardRef(
  ({ className, min = 0, max = 100, step = 1, defaultValue = [0], onValueChange, ...props }, ref) => {
    const [value, setValue] = useState(defaultValue)

    useEffect(() => {
      setValue(defaultValue)
    }, [defaultValue])

    const handleChange = (e) => {
      const newValue = [Number.parseInt(e.target.value)]
      setValue(newValue)
      if (onValueChange) {
        onValueChange(newValue)
      }
    }

    return (
      <div className={`slider-container ${className || ""}`} ref={ref}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value[0]}
          onChange={handleChange}
          className="slider"
          {...props}
        />
      </div>
    )
  },
)

Slider.displayName = "Slider"

export default Slider

